export default {
  startAnalytics(gtm_code) {
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-' + gtm_code);
  },
  pushVirtualPageview(page_url, page_title) {
    if (typeof dataLayer !== 'undefined' && dataLayer !== null) {
      dataLayer.push({
          'event': 'VirtualPageview',
          'virtualPageURL': page_url,
          'virtualPageTitle': page_title
      });
    }
  },
  pushEvent(event) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': event
    });
  }
}



// WEBPACK FOOTER //
// ./src/analytics.js